import * as Styled from './styles';
import { FormContainerProps } from './types';

const FormContainer = ({
  children,
  className,
  onSubmit,
  testID,
}: FormContainerProps): JSX.Element => (
  <Styled.Container className={className} data-testid={testID} onSubmit={onSubmit}>
    {children}
  </Styled.Container>
);

export default FormContainer;
